import { parseSpreadsheetText, SPREADSHEET_LIMITS, type SpreadsheetSheet } from "./spreadsheetImport";


export async function readSpreadsheetFile(file: File, signal?: AbortSignal): Promise<SpreadsheetSheet[]> {
  if (file.size > SPREADSHEET_LIMITS.bytes) throw new Error("Choose a spreadsheet under 5 MB.");
  if (!/\.(xlsx|csv|tsv)$/i.test(file.name)) throw new Error("Choose an Excel (.xlsx), CSV or TSV file. You can also copy and paste cells.");
  if (!/\.xlsx$/i.test(file.name)) return [{ name: file.name, rows: parseSpreadsheetText(await file.text(), /\.tsv$/i.test(file.name) ? "\t" : undefined) }];
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL("./spreadsheetReader.worker.ts", import.meta.url), { type: "module" });
    let done = false;
    const finish = (sheets?: SpreadsheetSheet[], error?: Error) => {
      if (done) return; done = true; clearTimeout(timeout); signal?.removeEventListener("abort", abort); worker.terminate();
      if (error) reject(error); else resolve(sheets!);
    };
    const abort = () => finish(undefined, new DOMException("Reading cancelled", "AbortError"));
    const timeout = window.setTimeout(() => finish(undefined, new Error("This workbook is taking too long to read. Save just the inventory worksheet or paste its cells.")), 30_000);
    worker.onmessage = (event: MessageEvent<{ sheets?: SpreadsheetSheet[]; error?: string }>) => finish(event.data.sheets, event.data.error ? new Error(event.data.error) : undefined);
    worker.onerror = () => finish(undefined, new Error("Could not read this workbook. Save a fresh .xlsx copy or paste its cells."));
    signal?.addEventListener("abort", abort, { once: true });
    if (signal?.aborted) abort(); else worker.postMessage(file);
  });
}
